import { render, staticRenderFns } from "./ExpandedIcon2.vue?vue&type=template&id=5e033340&scoped=true&"
import script from "./ExpandedIcon2.vue?vue&type=script&lang=js&"
export * from "./ExpandedIcon2.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedIcon2.vue?vue&type=style&index=0&id=5e033340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e033340",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
